<template>
<div>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn padbtn">
          <div class="col-4" v-if="canCreate()">
            <button class="btn btn-secondary btn-fg custom-shadow-btn" @click="openModal('create')">
              <i class="fa fa-plus"></i>
              Agregar Departamento
            </button>
          </div>          
        </div>
        <hr>
        <div class="row">
          <div class="col-12 text-center">
            <h6 class="text-muted">Departamentos Activos</h6>
          </div>        
        </div>  
        <div v-if="canIndex()">
          <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <el-select
              class="select-default mb-3"
              style="width: 200px"
              v-model="pagination.perPage"
              placeholder="Por pagina">
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
            <el-input type="search"
                      class="mb-3"
                      style="width: 200px"
                      placeholder="Buscar registros"
                      v-model="searchQuery"
                      aria-controls="datatables"/>
          </div>
          <div class="col-sm-12">
            <el-table 
                      style="width: 100%;"
                      :data="queriedData"
                      border>
              <el-table-column type="index" width="65"></el-table-column>                      
              <el-table-column v-for="column in tableColumns"
                               :key="column.label"
                               :min-width="column.minWidth"
                               :prop="column.prop"
                               :label="column.label">
              </el-table-column>
              <el-table-column label="Empresas" minWidth="200" prop="companies[0].name">
                <template slot-scope="scope">                                            
                  <el-badge class="custom-el-badge__content item" v-if="scope.row.companies.length > 0" 
                  :hidden="(scope.row.companies.length == 1) ? true : false"
                  :value="200" :max="scope.row.companies.length-1">
                    <el-button plain type="danger" size="small">{{scope.row.companies[0].company}}, ...  </el-button>
                  </el-badge>                  
                </template>
              </el-table-column>                 
              <el-table-column
                :min-width="120"
                fixed="right"
                label="Acciones">
                <template slot-scope="props">
                  <a v-if="canShow()" v-tooltip.top-center="'Ver'" class="btn-info btn-simple btn-link"
                     @click="handleView(props.$index, props.row)">
                    <i class="fa fa-eye"></i></a>
                  <a v-if="canUpdate()" v-tooltip.top-center="'Editar'" class="btn-warning btn-simple btn-link"
                     @click="handleEdit(props.$index, props.row)"><i
                    class="fa fa-edit"></i></a>
                  <a v-if="canDelete()" v-tooltip.top-center="'Borrar'" class="btn-danger btn-simple btn-link"
                     @click="handleDelete(props.$index, props.row)"><i class="fa fa-times"></i></a>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <div class="text-center">
            <h4> <strong> No tienes permiso para indexar información </strong></h4>
          </div>
        </div>        
        <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <div class="">
            <p class="card-category">Mostrando {{from + 1}} a {{to}} de {{total}} entradas</p>
          </div>
          <l-pagination class="pagination-no-border"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </l-pagination>
        </div>
      </card>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <div class="text-right" v-if="canPDF()">
        <button class="btn btn-danger btn-fg custom-shadow-btn" @click="exportToPDF('departments/pdf', 'departamentos.pdf')">
          <i class="fa fa-file-pdf-o"></i>
          Exportar a PDF
        </button>
      </div>
    </div>
    <div class="col-6">
      <div class="text-left" v-if="canExcel()">
        <button class="btn btn-success btn-fg custom-shadow-btn" @click="exportToExcel('departments/excel', 'departamentos.xlsx')">
          <i class="fa fa-file-excel-o"></i>
          Exportar a Excel
        </button>
      </div>
    </div>
    <el-dialog v-if="canCreate() || canUpdate()"
      :title="title"
      :visible.sync="modals.create">
      <form>
        <div class="row">
          <div class="col-12">
            <fg-input 
            type="text" 
            label="Nombre *" 
            v-model="departmentForm.department"
            v-validate="modelValidations.department"
            name="nombre del departamento"
            :error="getError('nombre del departamento')"
            :disabled="disabledField">
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label>Empresas *</label>
            <el-select  multiple :class="selectClass" class="select_modules select-primary"
                        v-model="departmentForm.companies"
                        filterable placeholder="Seleccione una o varias empresas">
              <el-option v-for="option in companies"
                          class="select-primary"
                          :value="option.id"
                          :label="option.company"
                          :key="option.company">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row" v-if="errorAlert ">
          <div class="col-lg-12"><br>
            <el-alert
              :title="errorAlert"
              type="error">
            </el-alert>
          </div>        
        </div>
      </form>          
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-danger" @click="closeModal('create')">Cancelar</button>&nbsp;
        <button class="btn btn-success" @click="validateForm">Confirmar</button>
      </span>
    </el-dialog>
    <el-dialog v-if="canShow()"
      :title="title"
      :visible.sync="modals.read">
        <p>A continuación encontrarás toda la información asociada al registro seleccionado.</p>
        <div class="card" v-if="rowData">
          <div class="card-body">
            <table class="table">
              <tbody v-if="rowData">
                <tr class="shadow-sm">
                  <td scope="row">
                    <h6><b>Nombre:</b></h6>
                    {{rowData.department}}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td scope="row">
                    <h6 class="custom-margin-h6-table"><b>Empresas:</b></h6>
                    <template v-for="(companie, index) in rowData.companies">
                      <el-tag :key="companie.id"
                        size="small"
                        type="danger"
                        :closable="false"
                        :close-transition="false">
                          {{companie.company}}                
                      </el-tag>       
                      <br :key="index+'Index'" v-if="(((index+1) % 3) == 0)"/>
                    </template>                
                  </td>
                </tr>            
              </tbody>
            </table>
          </div>
            <div class="card-footer footer-date-at" v-if="rowData">
              <p class="text-muted"><small>Creado el: {{rowData.created_at}}</small></p>
            </div>
        </div>
    </el-dialog>
  </div>
</div>
</template>
<script>
  import mixinMasters from 'src/util/mixinMasters'
  import mixinPermissions from 'src/util/mixinPermissions'
  import showSwalAlert from 'src/util/alerts'
  import table from './departmentTable'
  import moment from 'moment';

  export default {
    data () {
      return {
        departmentForm: {
          department: null, 
          companies: [],
        },
        modelValidations: {
          department: {
            required: true,
          }
        },
        companies: null,
        modals: {
          create: false,
        },    
        tableColumns: table,
      }
    },
    mixins: [mixinMasters, mixinPermissions],
    methods: {
      openModal (name) {
        if (name == 'create'){
          this.title = 'Agregar un Departamento',
          this.$validator.reset();
          this.departmentForm = {
            department: null, 
            companies: [],
          }
          this.disabledField = false
        }
        this.modals[name] = true
      },
      validateForm(name){
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            if ( this.departmentForm.companies.length != 0) this.addEditDepartment()
            else {
              this.selectClass = 'select-danger'
              this.errorAlert = 'Debe seleccionar una o mas empresas'
              setTimeout(()=>{
                this.selectClass = "select-primary"
                this.errorAlert = null
              }, 5000)
            }
          }
        })
      },
      handleView (index, row) {
        this.rowData = Object.assign({}, row)
        this.rowData.created_at = moment(String(this.rowData.created_at)).format('MM/DD/YYYY hh:mm:ss')
        this.title = 'Departamento '+this.rowData.department
        this.modals['read'] = true
      },
      handleEdit (index, row) {
        this.title = 'Editar Departamento '+ row.department
        this.departmentForm = Object.assign({}, row)
        this.departmentForm.companies = row.companies_ids
        this.departmentForm.route = 'departments'
        this.disabledField = true
        this.errors.clear();
        this.modals['create'] = true
      },
      handleDelete (index, row) {      
        this.departmentForm = Object.assign({}, row)
        this.departmentForm.companies = row.companies_ids
        showSwalAlert('Departamento', 'delete', null, 'departamento: '+row.department).then((result) => {
          if (result.value) this.deleteDepartment()
        })
      },
      addEditDepartment(){
        if (this.departmentForm.route == 'departments'){          
          this.updateMaster(this.departmentForm).then((response) => this.modifyTable(1, this.departmentForm.id, response))             
        } else {
          this.departmentForm.route = 'departments'
          this.saveMaster(this.departmentForm).then((response) => {
            this.modifyTable(0, this.departmentForm.id, response)                 
          }).catch((error) => {
            if(error.response.data.errors.department){
              this.departmentForm.route = null
              this.errorAlert = error.response.data.errors.department[0]
              setTimeout(()=>{ this.errorAlert = null }, 5000)            
            }
          })
        }
      },  
      deleteDepartment(){
        this.departmentForm.route = 'departments'
        this.destroyMaster(this.departmentForm).then((response) => this.modifyTable(2, this.departmentForm.id, response))
      },
    },
    created(){
      if(this.canIndex()){
        this.getMasters('departments').then((response) => {
          this.tableData = response.data.data
          this.searchFuse(['department', 'companies.company'])
        })
        this.getMasters('companies/index').then((response) => this.companies = response.data.data)
      }
    },
  }
</script>
<style>
</style>
